module.exports = __webpack_public_path__ + "img/logo.e30da39e.png";